import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectService } from '../../services/project.service';
import { ToastrService } from 'ngx-toastr';
import { DirectionService } from '../../services/direction.service';
import { StrategyService } from '../../services/strategy.service';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-department-approvals',
  standalone: true,
  imports: [
    NavTitlePipe,
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    TagModule,
    DialogModule,
    InputTextareaModule,
    TooltipModule,
    FormsModule,
    TranslateModule
  ],
  templateUrl: './department-approvals.component.html',
  styleUrl: './department-approvals.component.scss'
})
export class DepartmentApprovalsComponent implements OnInit {
  
  pendingProjects: any[] = [];
  selectedProject: any = null;
  showApprovalDialog = false;
  approvalNote = '';
  isProcessing = false;
  dir!: 'rtl' | 'ltr';
  selectedStrategyId = 0;
  
  // Pagination
  currentPage = 1;
  pageSize = 10;
  totalCount = 0;
  totalPages = 0;
  Math = Math; // Expose Math to template

  constructor(
    private projectService: ProjectService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private strategyService: StrategyService
  ) {}

  ngOnInit(): void {
    this.directionService.direction$.subscribe(dir => {
      this.dir = dir;
    });

    this.strategyService.defaultStrategy$.subscribe(strategy => {
      this.selectedStrategyId = strategy?.id || 0;
      if (this.selectedStrategyId) {
        this.loadPendingProjects();
      }
    });
  }

  loadPendingProjects() {
    console.log('[DEPT APPROVALS] Loading pending projects for strategy:', this.selectedStrategyId, 'Page:', this.currentPage);
    
    // Get projects pending department approval with pagination
    this.projectService.getDepartmentPendingProjects(this.selectedStrategyId, this.currentPage, this.pageSize).subscribe({
      next: (response: any) => {
        console.log('[DEPT APPROVALS] Full API response:', response);
        this.pendingProjects = response?.data?.projects || [];
        
        // Update pagination info
        if (response?.data?.pagination) {
          this.currentPage = response.data.pagination.page;
          this.pageSize = response.data.pagination.page_size;
          this.totalCount = response.data.pagination.total_count;
          this.totalPages = response.data.pagination.total_pages;
        }
        
        console.log('[DEPT APPROVALS] Pending projects count:', this.pendingProjects.length);
        console.log('[DEPT APPROVALS] Total count:', this.totalCount);
        console.log('[DEPT APPROVALS] Pending projects:', this.pendingProjects);
        
        // Debug each project
        this.pendingProjects.forEach((p: any, i: number) => {
          console.log(`[DEPT APPROVALS] Project ${i + 1}:`, {
            name: p.name,
            status: p.assessment_status,
            assessments: p.assessments
          });
        });
      },
      error: (err) => {
        console.error('[DEPT APPROVALS] Error loading pending projects:', err);
        this.toastr.error(
          this.dir === 'rtl' ? 'فشل تحميل المبادرات' : 'Failed to load projects',
          this.dir === 'rtl' ? 'خطأ' : 'Error'
        );
      }
    });
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.loadPendingProjects();
  }

  openPreviewDialog(project: any) {
    this.selectedProject = { ...project };
    this.approvalNote = '';
    this.showApprovalDialog = true;
  }

  submitDecision(approve: boolean) {
    if (!this.selectedProject) return;

    this.selectedProject.willApprove = approve;
    this.isProcessing = true;
    
    const approvalData = {
      ProjectId: this.selectedProject.id,
      IsApproved: approve,
      Note: this.approvalNote || ''
    };

    this.projectService.approveProject(this.selectedStrategyId, this.selectedProject.id, approvalData)
      .subscribe({
        next: (response: any) => {
          this.isProcessing = false;
          this.showApprovalDialog = false;
          
          const successMsg = approve
            ? (this.dir === 'rtl' ? 'تم اعتماد المبادرة بنجاح' : 'Project approved successfully')
            : (this.dir === 'rtl' ? 'تم رفض المبادرة' : 'Project rejected');
          
          this.toastr.success(successMsg, this.dir === 'rtl' ? 'نجاح' : 'Success');
          
          // Reload projects
          this.loadPendingProjects();
        },
        error: (err) => {
          this.isProcessing = false;
          console.error('Error submitting decision:', err);
          this.toastr.error(
            this.dir === 'rtl' ? 'فشل في تقديم القرار' : 'Failed to submit decision',
            this.dir === 'rtl' ? 'خطأ' : 'Error'
          );
        }
      });
  }

  getSeverity(status: string): string {
    return 'warning'; // Always pending for this view
  }
}

